(function ($) {
    $(window).on('load', function () {
        let adminIdLength = $("body#admin-logged-in").length;
        if (adminIdLength == 0) {
            $('.node-edit').each(function () {
                $(this).remove();
            });
        } else {
            $('.node-edit').css("display", "inline-block");
        }
    });
})(jQuery);